import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  UserIcon,
  PhoneIcon,
  EnvelopeIcon,
  BuildingOfficeIcon,
  ChevronDownIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';
import './OutsourceRequest.css';
import axios from 'axios';
import toast from 'react-hot-toast';

const OutsourceRequest = ({ showModal, setShowModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    description: ''
  });

  const [showDropdown, setShowDropdown] = useState(false);

  const outsourcingServices = [
    "GST Filing (India)",
    "Income Tax Returns (India)",
    "TDS Compliance (India)",
    "ROC Compliance (India)",
    "Accounting & Bookkeeping (India)",
    "Payroll Processing (India)",
    "Accounting and Bookkeeping (US)",
    "Digital Bookkeeping (US)",
    "Year-End Accounts (US)",
    "Tax Preparation (US)",
    "Self-Assessment Tax Returns (US)",
    "Company Tax Returns (US)",
    "Company Secretarial Services (US)",
    "VAT Services (US)",
    "Audit and Assurance (US)",
    "Payroll Services (US)",
    "UI/UX Designers",
    "Web Developers",
    "Backend Developers",
    "Content Writers"
  ];

  const handleSubmit = async(e) => {
    e.preventDefault();
    try{
   const response = await axios.post("https://api.krinvy.com/api/postoutsourcing",formData);
   if(response.data.success){
    toast.success(response.data.message)
     setShowModal(false);
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: '',
      service: '',
      description: ''
    });
   }
    }catch(error){
  if(error.response && error.response.data && error.response.data.error){
    toast.error(error.response.data.error)
  }
    }
    
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const selectService = (service) => {
    setFormData(prev => ({
      ...prev,
      service
    }));
    setShowDropdown(false);
  };

  return (
    <AnimatePresence>
      {showModal && (
        <div className="or-modal-overlay or-active">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="or-modal-container"
          >
            <div className="or-modal-content-wrapper">
              {/* Left Side - Content */}
              <div className="or-modal-content-left">
                <h2>Outsource with Confidence</h2>
                <p>Let our experts handle your business processes while you focus on growth and innovation.</p>
              </div>

              {/* Right Side - Form */}
              <div className="or-modal-content-right">
                <div className="or-modal-header">
                  <div className="or-modal-header-content">
                    <h3 className="or-modal-title">Outsourcing Service Request</h3>
                    <button 
                      className="or-modal-close-btn"
                      onClick={() => setShowModal(false)}
                    >
                      <XMarkIcon className="or-close-icon" />
                    </button>
                  </div>
                </div>

                <div className="or-modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="or-form-group">
                      <label className="or-form-label">Full Name*</label>
                      <div className="or-input-with-icon">
                        <UserIcon className="or-input-icon" />
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="or-form-control"
                          required
                          placeholder="Your name"
                        />
                      </div>
                    </div>

                    <div className="or-form-group">
                      <label className="or-form-label">Company Name*</label>
                      <div className="or-input-with-icon">
                        <BuildingOfficeIcon className="or-input-icon" />
                        <input
                          type="text"
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                          className="or-form-control"
                          required
                          placeholder="Your company name"
                        />
                      </div>
                    </div>

                    <div className="or-form-group">
                      <label className="or-form-label">Email*</label>
                      <div className="or-input-with-icon">
                        <EnvelopeIcon className="or-input-icon" />
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="or-form-control"
                          required
                          placeholder="Your email"
                        />
                      </div>
                    </div>

                    <div className="or-form-group">
                      <label className="or-form-label">Phone Number*</label>
                      <div className="or-input-with-icon">
                        <PhoneIcon className="or-input-icon" />
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="or-form-control"
                          required
                          placeholder="Your phone number"
                        />
                      </div>
                    </div>

                    <div className="or-form-group">
                      <label className="or-form-label">Service Needed*</label>
                      <div className="or-custom-select">
                        <div 
                          className="or-select-header"
                          onClick={() => setShowDropdown(!showDropdown)}
                        >
                          <span className="or-selected-value">
                            {formData.service || "Select a service"}
                          </span>
                          <ChevronDownIcon className={`or-chevron-icon ${showDropdown ? 'or-rotate' : ''}`} />
                        </div>
                        {showDropdown && (
                          <div className="or-select-dropdown">
                            {outsourcingServices.map((service, index) => (
                              <div
                                key={index}
                                className="or-select-option"
                                onClick={() => selectService(service)}
                              >
                                {service}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="or-form-group">
                      <label className="or-form-label">Project Details</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows={4}
                        className="or-form-control"
                        placeholder="Tell us about your project requirements"
                      />
                    </div>

                    <div className="or-form-actions">
                      <button
                        type="submit"
                        className="or-btn or-btn-primary"
                      >
                        Request Service
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default OutsourceRequest;